import { render, staticRenderFns } from "./MenuBlClient.vue?vue&type=template&id=2cc5a5e3&scoped=true&"
import script from "./MenuBlClient.vue?vue&type=script&lang=js&"
export * from "./MenuBlClient.vue?vue&type=script&lang=js&"
import style0 from "./MenuBlClient.vue?vue&type=style&index=0&id=2cc5a5e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5a5e3",
  null
  
)

export default component.exports